let mesAnterior = new Date().getMonth() + 1;
mesAnterior = mesAnterior < 10 ? "0" + mesAnterior : mesAnterior;

const INITIAL_STATE = {
    registro: {},
    aguardando: false,
    modoTela: "lista",
    situacaoAtual: {},
    listaCliente: [],
    listaUnidadeConsumidora: [],
    listaModalidadeMercadoLivre: [],
    listaTipoEnergiaMercadoLivre: [],
    filtro: {
        id_cliente: null,
        id_unidade_consumidora: null,
        id_grupo_faturamento: null,
        competencia_inicial: `${new Date().getFullYear()}01`,
        competencia_final: `${new Date().getFullYear()}${mesAnterior}`,
    },
    listaTipoAnalise: [
        { id: "Mercado Livre", valor: "Mercado Livre" },
        { id: "Aluguel de Usina", valor: "Aluguel de Usina" },
        { id: "Opção Tarifária (Optantes A ou B)", valor: "Opção Tarifária (Optantes A ou B)" },
        { id: "Modalidade Tarifária (Verde ou Azul)", valor: "Modalidade Tarifária (Verde ou Azul)" },
        { id: "Geração Própria", valor: "Geração Própria" },
    ],
    tarifasAneelSimulacao: {
        tarifa_energia_tusd: 0,
        tarifa_energia_te: 0,
        tarifa_energia_fora_ponta_tusd: 0,
        tarifa_energia_fora_ponta_te: 0,
        tarifa_energia_ponta_tusd: 0,
        tarifa_energia_ponta_te: 0,
    },
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "DIAGNOSTICO_ENERGIA_MODO_TELA":
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro,
            };

        case "DIAGNOSTICO_ENERGIA_SET_AGUARDANDO":
            return { ...state, aguardando: action.payload };

        case "DIAGNOSTICO_ENERGIA_FILTRO":
            return {
                ...state,
                filtro: {
                    ...action.payload,
                },
            };

        case "DIAGNOSTICO_ENERGIA_RESETAR_FILTRO":
            return {
                ...state,
                filtro: {
                    id_cliente: null,
                    id_unidade_consumidora: null,
                },
            };

        case "DIAGNOSTICO_ENERGIA_LISTADO":
            return {
                ...state,
                situacaoAtual: action.payload,
            };

        case "DIAGNOSTICO_ENERGIA_CLIENTE_SELECT_LISTADO":
            return {
                ...state,
                listaCliente: action.payload.data,
            };

        case "DIAGNOSTICO_ENERGIA_UNIDADE_CONSUMIDORA_SELECT_LISTADO":
            return {
                ...state,
                listaUnidadeConsumidora: action.payload.data,
            };

        case "DIAGNOSTICO_ENERGIA_MODALIDADE_MERCADO_LIVRE_SELECT_LISTADO":
            return {
                ...state,
                listaModalidadeMercadoLivre: action.payload.data,
            };

        case "DIAGNOSTICO_ENERGIA_TIPO_ENERGIA_MERCADO_LIVRE_SELECT_LISTADO":
            return {
                ...state,
                listaTipoEnergiaMercadoLivre: action.payload.data,
            };

        case "DIAGNOSTICO_ENERGIA_TARIFAS_SIMULACAO":
            return {
                ...state,
                tarifasAneelSimulacao: action.payload,
            };

        default:
            return state;
    }
};
